import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/longBeach/budget';
const req = require.context('!raw-loader!../../../markdowns/longBeach/budget', false, /\.(md|jsx)$/);

export default function Budget() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
